import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const admin = {
    id: 'admin',
    type: 'group',
    title: 'Menu Administrativo',
    children: [
        {
            id: 'default',
            title: 'Reservar Sala',
            type: 'item',
            url: '/agendamentos',
            icon: EditCalendarOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'meus-agendamentos',
            title: 'Meus Agendamentos',
            type: 'item',
            url: '/meus-agendamentos',
            icon: ListAltOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'timeline',
            title: 'Agenda do Dia',
            type: 'item',
            url: '/timeline',
            icon: EventNoteOutlinedIcon,
            breadcrumbs: false,
            color: 'success',
            variant: 'success',
            target: '_blank'
        },
        {
            id: 'locations',
            title: 'Locais',
            type: 'item',
            url: '/locais',
            icon: RoomOutlinedIcon,
            breadcrumbs: false,
            color: 'success',
            variant: 'success'
        },
        {
            id: 'users',
            title: 'Usuários',
            type: 'item',
            url: '/usuarios',
            icon: PeopleAltOutlinedIcon,
            breadcrumbs: false,
            color: 'success',
            variant: 'success'
        },
        {
            id: 'tags',
            title: 'Tags',
            type: 'item',
            url: '/tags',
            icon: LocalOfferOutlinedIcon,
            breadcrumbs: false,
            color: 'success',
            variant: 'success'
        },
        {
            id: 'settings',
            title: 'Configurações',
            type: 'item',
            url: '/configuracoes',
            icon: SettingsOutlinedIcon,
            breadcrumbs: false,
            color: 'success',
            variant: 'success'
        },
        {
            id: 'reports',
            title: 'Relatórios',
            type: 'item',
            url: '/relatorios',
            icon: AssessmentOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'contacts',
            title: 'Contatos',
            type: 'item',
            url: '/contatos',
            icon: ContactsOutlinedIcon,
            breadcrumbs: false,
            color: 'success',
            variant: 'success'
        }
    ]
};

export default admin;
